export default class LaptopDestroyEvent {
    constructor(type) {
        this.type = type;
    }
}

LaptopDestroyEvent.PERFORM = 'LaptopDestroyEvent.PERFORM';